<template>
    <div class="col">
        <div class="card">
            <img :src="gallery.img" class="card-img-top gallery-card-image">
            <div class="card-body">
                <h2 class="card-title">{{gallery.title}}</h2>
                <h6 class="card-subtitle mb-2 text-muted">{{gallery.subtitle}}</h6>
                <gallery-page-text :text="gallery.text" :designer_url="gallery.designer_url"
                                   :designer_title="gallery.designer_title"/>
                <router-link :to="{ name: 'gallery', params: {slug: gallery.slug}}" class="btn btn-dark">
                    {{gallery.title}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
  import GalleryPageText from './GalleryPageText';

  export default {
    name: 'gallery-card',
    components: {
      GalleryPageText,
    },
    props: {
      gallery: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped>
</style>
